module.exports = __webpack_public_path__ + "assets/img/loading-1d217100.gif";